const ConfigDB = {
    settings: {
        layout_type: 'ltr',
        layout_class: 'compact-wrapper',
        sidebar: {
            type: 'compact-wrapper',
            iconType: 'stroke-svg',
        },
        sidebar_setting: 'default-sidebar',
    },
    color: {
        primary_color: localStorage.getItem('primary') || '#0766AD',
        secondary_color: localStorage.getItem('secondary') || '#29ADB2',
        mix_background_layout: 'dark-sidebar',
    },
    router_animation: 'fadeIn',
};

export default ConfigDB;